module.exports = __webpack_public_path__ + "static/media/ie.deca9e10.svg";